<template>

<app-panel v-on:close="$emit('close')" :theme="(is.saved) ? 'green' : 'default'">
		
	<app-panel-content class="location-text"> 

        <h1>Looking for Player</h1>
        <p>Let other people know you're looking for a player right now. Your flag will appear for 10 minutes or until you no longer need it. Please give as accurate a location as possible so they can find you.</p>
    
	</app-panel-content>

	<app-panel-content>

		<app-input-text placeholder="Enter event name" :disabled="is.loading || is.saved" :stacked="true" v-model="model.name" :validation="$v.model.name" />
		<app-input-text placeholder="Enter location / directions" :autogrow="true" :disabled="is.loading || is.saved" :stacked="true" v-model="model.location" :validation="$v.model.location" />

	</app-panel-content>

	<app-panel-content class="location-buttons" v-if="!is.saved">

		<app-button text="Confirm" :loading="is.loading" :disabled="!model.name && !model.location" v-on:click.native.stop="onConfirmClick" v-if="!is.saved" />
		<app-button text="Close" theme="simple" v-on:click.native.stop="$emit('close')" />

	</app-panel-content>

	<app-panel-content v-if="is.saved">

		<app-button text="Close" theme="darkgreen" v-on:click.native.stop="$emit('close')" />

	</app-panel-content>

</app-panel>

</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

export default {

	mixins: [validationMixin],

	props: ['data' ,'event'],

	data: function() {

		return {
			is: {
				loading: false,
                saved: false
			},
			model: {
				name: '',
                location: ''
			}
		}

	},

	validations: {
		model: {
			name: {
				required,
                minLength: minLength(1)
			},
			location: {
				required,
                minLength: minLength(1)
			}
		}
	},

	created: function() {

		this.$pubsub.$emit('offset', true)

	},

	beforeDestroy: function() {

		this.$pubsub.$emit('offset', false)

	},

	methods: {

		onConfirmClick: function() {

			this.is.loading = true

			this.$api.post('convention/looking', this.model).then(function() {

				this.is.loading = false
                this.is.saved = true

			}.bind(this));

		}

	}

}

</script>

<style scoped>

.location-buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
}

.location-text {
    padding-top: 20px;
}

.location-text h1 {
    font-size: 24px;
    margin-bottom: 10px;
}

.location-text h2 {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
}

.location-text p {
    font-size: 16px;
    line-height: 20px;
    color: #fff;
}

</style>
